import { CandyGraph } from "../candygraph";
import { Font } from "./font";

function loadImage(url: string) {
  return new Promise<HTMLImageElement>((accept) => {
    const image = new Image();
    image.onload = () => accept(image);
    image.src = url;
  });
}

export function createDefaultFont(cg: CandyGraph) {
  return new Promise<Font>(async (accept) => {
    const image = await loadImage(latoImage);
    const font = new Font(cg, image, latoJSON);
    accept(font);
  });
}

const latoJSON = {
  pages: ["Lato-Regular.png"],
  chars: [
    {
      id: 87,
      index: 58,
      char: "W",
      width: 46,
      height: 34,
      xoffset: -2,
      yoffset: 6,
      xadvance: 43,
      chnl: 15,
      x: 1,
      y: 1,
      page: 0,
    },
    {
      id: 36,
      index: 7,
      char: "$",
      width: 24,
      height: 43,
      xoffset: 0,
      yoffset: 2,
      xadvance: 24,
      chnl: 15,
      x: 48,
      y: 1,
      page: 0,
    },
    {
      id: 40,
      index: 11,
      char: "(",
      width: 12,
      height: 43,
      xoffset: 1,
      yoffset: 3,
      xadvance: 13,
      chnl: 15,
      x: 73,
      y: 1,
      page: 0,
    },
    {
      id: 41,
      index: 12,
      char: ")",
      width: 12,
      height: 43,
      xoffset: 0,
      yoffset: 3,
      xadvance: 13,
      chnl: 15,
      x: 86,
      y: 1,
      page: 0,
    },
    {
      id: 124,
      index: 95,
      char: "|",
      width: 7,
      height: 43,
      xoffset: 3,
      yoffset: 4,
      xadvance: 13,
      chnl: 15,
      x: 99,
      y: 1,
      page: 0,
    },
    {
      id: 91,
      index: 62,
      char: "[",
      width: 12,
      height: 42,
      xoffset: 1,
      yoffset: 4,
      xadvance: 13,
      chnl: 15,
      x: 107,
      y: 1,
      page: 0,
    },
    {
      id: 93,
      index: 64,
      char: "]",
      width: 12,
      height: 42,
      xoffset: 0,
      yoffset: 4,
      xadvance: 13,
      chnl: 15,
      x: 107,
      y: 44,
      page: 0,
    },
    {
      id: 106,
      index: 77,
      char: "j",
      width: 13,
      height: 42,
      xoffset: -3,
      yoffset: 5,
      xadvance: 11,
      chnl: 15,
      x: 1,
      y: 36,
      page: 0,
    },
    {
      id: 123,
      index: 94,
      char: "{",
      width: 14,
      height: 42,
      xoffset: -1,
      yoffset: 4,
      xadvance: 13,
      chnl: 15,
      x: 1,
      y: 79,
      page: 0,
    },
    {
      id: 125,
      index: 96,
      char: "}",
      width: 14,
      height: 42,
      xoffset: 0,
      yoffset: 4,
      xadvance: 13,
      chnl: 15,
      x: 15,
      y: 36,
      page: 0,
    },
    {
      id: 81,
      index: 52,
      char: "Q",
      width: 35,
      height: 41,
      xoffset: 0,
      yoffset: 6,
      xadvance: 34,
      chnl: 15,
      x: 16,
      y: 79,
      page: 0,
    },
    {
      id: 64,
      index: 35,
      char: "@",
      width: 35,
      height: 38,
      xoffset: 0,
      yoffset: 7,
      xadvance: 35,
      chnl: 15,
      x: 52,
      y: 87,
      page: 0,
    },
    {
      id: 47,
      index: 18,
      char: "/",
      width: 20,
      height: 37,
      xoffset: -2,
      yoffset: 5,
      xadvance: 16,
      chnl: 15,
      x: 88,
      y: 87,
      page: 0,
    },
    {
      id: 92,
      index: 63,
      char: "\\",
      width: 20,
      height: 37,
      xoffset: -2,
      yoffset: 5,
      xadvance: 16,
      chnl: 15,
      x: 52,
      y: 45,
      page: 0,
    },
    {
      id: 119,
      index: 90,
      char: "w",
      width: 36,
      height: 25,
      xoffset: -2,
      yoffset: 15,
      xadvance: 32,
      chnl: 15,
      x: 109,
      y: 87,
      page: 0,
    },
    {
      id: 37,
      index: 8,
      char: "%",
      width: 34,
      height: 35,
      xoffset: 0,
      yoffset: 6,
      xadvance: 33,
      chnl: 15,
      x: 120,
      y: 1,
      page: 0,
    },
    {
      id: 38,
      index: 9,
      char: "&",
      width: 32,
      height: 35,
      xoffset: 0,
      yoffset: 6,
      xadvance: 30,
      chnl: 15,
      x: 73,
      y: 45,
      page: 0,
    },
    {
      id: 48,
      index: 19,
      char: "0",
      width: 26,
      height: 35,
      xoffset: -1,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 120,
      y: 37,
      page: 0,
    },
    {
      id: 51,
      index: 22,
      char: "3",
      width: 24,
      height: 35,
      xoffset: 0,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 146,
      y: 73,
      page: 0,
    },
    {
      id: 56,
      index: 27,
      char: "8",
      width: 24,
      height: 35,
      xoffset: 0,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 147,
      y: 37,
      page: 0,
    },
    {
      id: 63,
      index: 34,
      char: "?",
      width: 19,
      height: 35,
      xoffset: -1,
      yoffset: 6,
      xadvance: 17,
      chnl: 15,
      x: 155,
      y: 1,
      page: 0,
    },
    {
      id: 67,
      index: 38,
      char: "C",
      width: 29,
      height: 35,
      xoffset: 0,
      yoffset: 6,
      xadvance: 29,
      chnl: 15,
      x: 171,
      y: 73,
      page: 0,
    },
    {
      id: 71,
      index: 42,
      char: "G",
      width: 30,
      height: 35,
      xoffset: 0,
      yoffset: 6,
      xadvance: 31,
      chnl: 15,
      x: 172,
      y: 37,
      page: 0,
    },
    {
      id: 77,
      index: 48,
      char: "M",
      width: 35,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 39,
      chnl: 15,
      x: 175,
      y: 1,
      page: 0,
    },
    {
      id: 79,
      index: 50,
      char: "O",
      width: 34,
      height: 35,
      xoffset: 0,
      yoffset: 6,
      xadvance: 34,
      chnl: 15,
      x: 211,
      y: 1,
      page: 0,
    },
    {
      id: 83,
      index: 54,
      char: "S",
      width: 24,
      height: 35,
      xoffset: -1,
      yoffset: 6,
      xadvance: 22,
      chnl: 15,
      x: 201,
      y: 73,
      page: 0,
    },
    {
      id: 98,
      index: 69,
      char: "b",
      width: 23,
      height: 35,
      xoffset: 1,
      yoffset: 5,
      xadvance: 23,
      chnl: 15,
      x: 203,
      y: 37,
      page: 0,
    },
    {
      id: 100,
      index: 71,
      char: "d",
      width: 23,
      height: 35,
      xoffset: 0,
      yoffset: 5,
      xadvance: 23,
      chnl: 15,
      x: 227,
      y: 37,
      page: 0,
    },
    {
      id: 102,
      index: 73,
      char: "f",
      width: 17,
      height: 35,
      xoffset: -1,
      yoffset: 5,
      xadvance: 14,
      chnl: 15,
      x: 30,
      y: 36,
      page: 0,
    },
    {
      id: 104,
      index: 75,
      char: "h",
      width: 22,
      height: 35,
      xoffset: 1,
      yoffset: 5,
      xadvance: 23,
      chnl: 15,
      x: 226,
      y: 73,
      page: 0,
    },
    {
      id: 105,
      index: 76,
      char: "i",
      width: 9,
      height: 35,
      xoffset: 1,
      yoffset: 5,
      xadvance: 11,
      chnl: 15,
      x: 246,
      y: 1,
      page: 0,
    },
    {
      id: 107,
      index: 78,
      char: "k",
      width: 22,
      height: 35,
      xoffset: 1,
      yoffset: 5,
      xadvance: 22,
      chnl: 15,
      x: 16,
      y: 121,
      page: 0,
    },
    {
      id: 108,
      index: 79,
      char: "l",
      width: 8,
      height: 35,
      xoffset: 1,
      yoffset: 5,
      xadvance: 11,
      chnl: 15,
      x: 39,
      y: 121,
      page: 0,
    },
    {
      id: 33,
      index: 4,
      char: "!",
      width: 9,
      height: 34,
      xoffset: 3,
      yoffset: 6,
      xadvance: 14,
      chnl: 15,
      x: 1,
      y: 122,
      page: 0,
    },
    {
      id: 35,
      index: 6,
      char: "#",
      width: 26,
      height: 34,
      xoffset: -1,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 1,
      y: 157,
      page: 0,
    },
    {
      id: 49,
      index: 20,
      char: "1",
      width: 22,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 1,
      y: 192,
      page: 0,
    },
    {
      id: 50,
      index: 21,
      char: "2",
      width: 24,
      height: 34,
      xoffset: 0,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 24,
      y: 192,
      page: 0,
    },
    {
      id: 52,
      index: 23,
      char: "4",
      width: 27,
      height: 34,
      xoffset: -1,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 28,
      y: 157,
      page: 0,
    },
    {
      id: 53,
      index: 24,
      char: "5",
      width: 23,
      height: 34,
      xoffset: 0,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 49,
      y: 192,
      page: 0,
    },
    {
      id: 54,
      index: 25,
      char: "6",
      width: 24,
      height: 34,
      xoffset: 0,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 56,
      y: 126,
      page: 0,
    },
    {
      id: 55,
      index: 26,
      char: "7",
      width: 24,
      height: 34,
      xoffset: 0,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 73,
      y: 161,
      page: 0,
    },
    {
      id: 57,
      index: 28,
      char: "9",
      width: 24,
      height: 34,
      xoffset: 1,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 81,
      y: 126,
      page: 0,
    },
    {
      id: 65,
      index: 36,
      char: "A",
      width: 32,
      height: 34,
      xoffset: -2,
      yoffset: 6,
      xadvance: 29,
      chnl: 15,
      x: 73,
      y: 196,
      page: 0,
    },
    {
      id: 66,
      index: 37,
      char: "B",
      width: 25,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 27,
      chnl: 15,
      x: 98,
      y: 161,
      page: 0,
    },
    {
      id: 68,
      index: 39,
      char: "D",
      width: 30,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 32,
      chnl: 15,
      x: 106,
      y: 125,
      page: 0,
    },
    {
      id: 69,
      index: 40,
      char: "E",
      width: 23,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 106,
      y: 196,
      page: 0,
    },
    {
      id: 70,
      index: 41,
      char: "F",
      width: 23,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 124,
      y: 160,
      page: 0,
    },
    {
      id: 72,
      index: 43,
      char: "H",
      width: 28,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 32,
      chnl: 15,
      x: 137,
      y: 113,
      page: 0,
    },
    {
      id: 73,
      index: 44,
      char: "I",
      width: 8,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 13,
      chnl: 15,
      x: 130,
      y: 195,
      page: 0,
    },
    {
      id: 74,
      index: 45,
      char: "J",
      width: 18,
      height: 34,
      xoffset: -1,
      yoffset: 6,
      xadvance: 19,
      chnl: 15,
      x: 139,
      y: 195,
      page: 0,
    },
    {
      id: 75,
      index: 46,
      char: "K",
      width: 28,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 29,
      chnl: 15,
      x: 148,
      y: 148,
      page: 0,
    },
    {
      id: 76,
      index: 47,
      char: "L",
      width: 21,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 22,
      chnl: 15,
      x: 166,
      y: 109,
      page: 0,
    },
    {
      id: 78,
      index: 49,
      char: "N",
      width: 28,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 32,
      chnl: 15,
      x: 158,
      y: 183,
      page: 0,
    },
    {
      id: 80,
      index: 51,
      char: "P",
      width: 24,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 26,
      chnl: 15,
      x: 158,
      y: 218,
      page: 0,
    },
    {
      id: 82,
      index: 53,
      char: "R",
      width: 26,
      height: 34,
      xoffset: 2,
      yoffset: 6,
      xadvance: 27,
      chnl: 15,
      x: 183,
      y: 218,
      page: 0,
    },
    {
      id: 84,
      index: 55,
      char: "T",
      width: 28,
      height: 34,
      xoffset: -1,
      yoffset: 6,
      xadvance: 25,
      chnl: 15,
      x: 177,
      y: 144,
      page: 0,
    },
    {
      id: 85,
      index: 56,
      char: "U",
      width: 28,
      height: 34,
      xoffset: 1,
      yoffset: 6,
      xadvance: 31,
      chnl: 15,
      x: 188,
      y: 109,
      page: 0,
    },
    {
      id: 86,
      index: 57,
      char: "V",
      width: 32,
      height: 34,
      xoffset: -2,
      yoffset: 6,
      xadvance: 29,
      chnl: 15,
      x: 187,
      y: 179,
      page: 0,
    },
    {
      id: 88,
      index: 59,
      char: "X",
      width: 30,
      height: 34,
      xoffset: -2,
      yoffset: 6,
      xadvance: 27,
      chnl: 15,
      x: 206,
      y: 144,
      page: 0,
    },
    {
      id: 89,
      index: 60,
      char: "Y",
      width: 30,
      height: 34,
      xoffset: -2,
      yoffset: 6,
      xadvance: 26,
      chnl: 15,
      x: 217,
      y: 109,
      page: 0,
    },
    {
      id: 90,
      index: 61,
      char: "Z",
      width: 27,
      height: 34,
      xoffset: 0,
      yoffset: 6,
      xadvance: 26,
      chnl: 15,
      x: 210,
      y: 214,
      page: 0,
    },
    {
      id: 103,
      index: 74,
      char: "g",
      width: 24,
      height: 33,
      xoffset: -1,
      yoffset: 14,
      xadvance: 21,
      chnl: 15,
      x: 220,
      y: 179,
      page: 0,
    },
    {
      id: 109,
      index: 80,
      char: "m",
      width: 33,
      height: 26,
      xoffset: 1,
      yoffset: 14,
      xadvance: 34,
      chnl: 15,
      x: 1,
      y: 227,
      page: 0,
    },
    {
      id: 112,
      index: 83,
      char: "p",
      width: 23,
      height: 33,
      xoffset: 1,
      yoffset: 14,
      xadvance: 23,
      chnl: 15,
      x: 237,
      y: 144,
      page: 0,
    },
    {
      id: 113,
      index: 84,
      char: "q",
      width: 23,
      height: 33,
      xoffset: 0,
      yoffset: 14,
      xadvance: 23,
      chnl: 15,
      x: 248,
      y: 109,
      page: 0,
    },
    {
      id: 116,
      index: 87,
      char: "t",
      width: 18,
      height: 33,
      xoffset: -1,
      yoffset: 8,
      xadvance: 16,
      chnl: 15,
      x: 249,
      y: 73,
      page: 0,
    },
    {
      id: 121,
      index: 92,
      char: "y",
      width: 25,
      height: 32,
      xoffset: -2,
      yoffset: 15,
      xadvance: 22,
      chnl: 15,
      x: 251,
      y: 37,
      page: 0,
    },
    {
      id: 59,
      index: 30,
      char: ";",
      width: 9,
      height: 30,
      xoffset: 1,
      yoffset: 15,
      xadvance: 11,
      chnl: 15,
      x: 56,
      y: 161,
      page: 0,
    },
    {
      id: 97,
      index: 68,
      char: "a",
      width: 21,
      height: 26,
      xoffset: 0,
      yoffset: 14,
      xadvance: 21,
      chnl: 15,
      x: 35,
      y: 227,
      page: 0,
    },
    {
      id: 99,
      index: 70,
      char: "c",
      width: 21,
      height: 26,
      xoffset: 0,
      yoffset: 14,
      xadvance: 20,
      chnl: 15,
      x: 256,
      y: 1,
      page: 0,
    },
    {
      id: 101,
      index: 72,
      char: "e",
      width: 23,
      height: 26,
      xoffset: 0,
      yoffset: 14,
      xadvance: 22,
      chnl: 15,
      x: 268,
      y: 70,
      page: 0,
    },
    {
      id: 110,
      index: 81,
      char: "n",
      width: 22,
      height: 26,
      xoffset: 1,
      yoffset: 14,
      xadvance: 23,
      chnl: 15,
      x: 277,
      y: 28,
      page: 0,
    },
    {
      id: 111,
      index: 82,
      char: "o",
      width: 24,
      height: 26,
      xoffset: 0,
      yoffset: 14,
      xadvance: 23,
      chnl: 15,
      x: 278,
      y: 1,
      page: 0,
    },
    {
      id: 114,
      index: 85,
      char: "r",
      width: 17,
      height: 26,
      xoffset: 1,
      yoffset: 14,
      xadvance: 17,
      chnl: 15,
      x: 238,
      y: 213,
      page: 0,
    },
    {
      id: 115,
      index: 86,
      char: "s",
      width: 19,
      height: 26,
      xoffset: -1,
      yoffset: 14,
      xadvance: 18,
      chnl: 15,
      x: 245,
      y: 178,
      page: 0,
    },
    {
      id: 117,
      index: 88,
      char: "u",
      width: 22,
      height: 26,
      xoffset: 1,
      yoffset: 15,
      xadvance: 23,
      chnl: 15,
      x: 261,
      y: 143,
      page: 0,
    },
    {
      id: 43,
      index: 14,
      char: "+",
      width: 24,
      height: 25,
      xoffset: 0,
      yoffset: 12,
      xadvance: 24,
      chnl: 15,
      x: 130,
      y: 230,
      page: 0,
    },
    {
      id: 58,
      index: 29,
      char: ":",
      width: 9,
      height: 25,
      xoffset: 1,
      yoffset: 15,
      xadvance: 11,
      chnl: 15,
      x: 57,
      y: 227,
      page: 0,
    },
    {
      id: 118,
      index: 89,
      char: "v",
      width: 25,
      height: 25,
      xoffset: -2,
      yoffset: 15,
      xadvance: 22,
      chnl: 15,
      x: 272,
      y: 97,
      page: 0,
    },
    {
      id: 120,
      index: 91,
      char: "x",
      width: 24,
      height: 25,
      xoffset: -1,
      yoffset: 15,
      xadvance: 21,
      chnl: 15,
      x: 292,
      y: 55,
      page: 0,
    },
    {
      id: 122,
      index: 93,
      char: "z",
      width: 20,
      height: 25,
      xoffset: -1,
      yoffset: 15,
      xadvance: 19,
      chnl: 15,
      x: 300,
      y: 28,
      page: 0,
    },
    {
      id: 126,
      index: 97,
      char: "~",
      width: 23,
      height: 11,
      xoffset: 0,
      yoffset: 20,
      xadvance: 24,
      chnl: 15,
      x: 109,
      y: 113,
      page: 0,
    },
    {
      id: 60,
      index: 31,
      char: "<",
      width: 20,
      height: 22,
      xoffset: 1,
      yoffset: 13,
      xadvance: 24,
      chnl: 15,
      x: 67,
      y: 231,
      page: 0,
    },
    {
      id: 61,
      index: 32,
      char: "=",
      width: 22,
      height: 14,
      xoffset: 1,
      yoffset: 17,
      xadvance: 24,
      chnl: 15,
      x: 238,
      y: 240,
      page: 0,
    },
    {
      id: 62,
      index: 33,
      char: ">",
      width: 20,
      height: 22,
      xoffset: 3,
      yoffset: 13,
      xadvance: 24,
      chnl: 15,
      x: 88,
      y: 231,
      page: 0,
    },
    {
      id: 94,
      index: 65,
      char: "^",
      width: 21,
      height: 18,
      xoffset: 1,
      yoffset: 6,
      xadvance: 24,
      chnl: 15,
      x: 272,
      y: 123,
      page: 0,
    },
    {
      id: 95,
      index: 66,
      char: "_",
      width: 21,
      height: 7,
      xoffset: -2,
      yoffset: 39,
      xadvance: 17,
      chnl: 15,
      x: 245,
      y: 205,
      page: 0,
    },
    {
      id: 42,
      index: 13,
      char: "*",
      width: 17,
      height: 18,
      xoffset: 0,
      yoffset: 4,
      xadvance: 17,
      chnl: 15,
      x: 109,
      y: 231,
      page: 0,
    },
    {
      id: 34,
      index: 5,
      char: '"',
      width: 14,
      height: 15,
      xoffset: 1,
      yoffset: 6,
      xadvance: 17,
      chnl: 15,
      x: 292,
      y: 81,
      page: 0,
    },
    {
      id: 39,
      index: 10,
      char: "'",
      width: 7,
      height: 15,
      xoffset: 1,
      yoffset: 6,
      xadvance: 10,
      chnl: 15,
      x: 48,
      y: 126,
      page: 0,
    },
    {
      id: 44,
      index: 15,
      char: ",",
      width: 9,
      height: 15,
      xoffset: 0,
      yoffset: 31,
      xadvance: 9,
      chnl: 15,
      x: 303,
      y: 1,
      page: 0,
    },
    {
      id: 45,
      index: 16,
      char: "-",
      width: 14,
      height: 7,
      xoffset: 0,
      yoffset: 22,
      xadvance: 15,
      chnl: 15,
      x: 261,
      y: 170,
      page: 0,
    },
    {
      id: 96,
      index: 67,
      char: "`",
      width: 12,
      height: 10,
      xoffset: -1,
      yoffset: 6,
      xadvance: 13,
      chnl: 15,
      x: 303,
      y: 17,
      page: 0,
    },
    {
      id: 46,
      index: 17,
      char: ".",
      width: 9,
      height: 9,
      xoffset: 0,
      yoffset: 31,
      xadvance: 9,
      chnl: 15,
      x: 148,
      y: 183,
      page: 0,
    },
    {
      id: 32,
      index: 3,
      char: " ",
      width: 0,
      height: 0,
      xoffset: -2,
      yoffset: 36,
      xadvance: 8,
      chnl: 15,
      x: 106,
      y: 45,
      page: 0,
    },
  ],
  info: {
    face: "Lato-Regular",
    size: 42,
    bold: 0,
    italic: 0,
    charset: [
      " ",
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "@",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "[",
      "\\",
      "]",
      "^",
      "_",
      "`",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "{",
      "|",
      "}",
      "~",
    ],
    unicode: 1,
    stretchH: 100,
    smooth: 1,
    aa: 1,
    padding: [2, 2, 2, 2],
    spacing: [0, 0],
  },
  common: {
    lineHeight: 50,
    base: 36,
    scaleW: 512,
    scaleH: 256,
    pages: 1,
    packed: 0,
    alphaChnl: 0,
    redChnl: 0,
    greenChnl: 0,
    blueChnl: 0,
  },
  distanceField: {
    fieldType: "sdf",
    distanceRange: 4,
  },
  kernings: [
    {
      first: 34,
      second: 38,
      amount: -4,
    },
    {
      first: 34,
      second: 44,
      amount: -5,
    },
    {
      first: 34,
      second: 45,
      amount: -4,
    },
    {
      first: 34,
      second: 46,
      amount: -5,
    },
    {
      first: 34,
      second: 47,
      amount: -4,
    },
    {
      first: 34,
      second: 64,
      amount: -1,
    },
    {
      first: 34,
      second: 65,
      amount: -4,
    },
    {
      first: 34,
      second: 67,
      amount: -1,
    },
    {
      first: 34,
      second: 71,
      amount: -1,
    },
    {
      first: 34,
      second: 79,
      amount: -1,
    },
    {
      first: 34,
      second: 81,
      amount: -1,
    },
    {
      first: 34,
      second: 86,
      amount: 1,
    },
    {
      first: 34,
      second: 87,
      amount: 1,
    },
    {
      first: 34,
      second: 89,
      amount: 1,
    },
    {
      first: 34,
      second: 92,
      amount: 1,
    },
    {
      first: 34,
      second: 97,
      amount: -1,
    },
    {
      first: 34,
      second: 99,
      amount: -2,
    },
    {
      first: 34,
      second: 100,
      amount: -2,
    },
    {
      first: 34,
      second: 101,
      amount: -2,
    },
    {
      first: 34,
      second: 111,
      amount: -2,
    },
    {
      first: 34,
      second: 113,
      amount: -2,
    },
    {
      first: 39,
      second: 38,
      amount: -4,
    },
    {
      first: 39,
      second: 44,
      amount: -5,
    },
    {
      first: 39,
      second: 45,
      amount: -4,
    },
    {
      first: 39,
      second: 46,
      amount: -5,
    },
    {
      first: 39,
      second: 47,
      amount: -4,
    },
    {
      first: 39,
      second: 64,
      amount: -1,
    },
    {
      first: 39,
      second: 65,
      amount: -4,
    },
    {
      first: 39,
      second: 67,
      amount: -1,
    },
    {
      first: 39,
      second: 71,
      amount: -1,
    },
    {
      first: 39,
      second: 79,
      amount: -1,
    },
    {
      first: 39,
      second: 81,
      amount: -1,
    },
    {
      first: 39,
      second: 86,
      amount: 1,
    },
    {
      first: 39,
      second: 87,
      amount: 1,
    },
    {
      first: 39,
      second: 89,
      amount: 1,
    },
    {
      first: 39,
      second: 92,
      amount: 1,
    },
    {
      first: 39,
      second: 97,
      amount: -1,
    },
    {
      first: 39,
      second: 99,
      amount: -2,
    },
    {
      first: 39,
      second: 100,
      amount: -2,
    },
    {
      first: 39,
      second: 101,
      amount: -2,
    },
    {
      first: 39,
      second: 111,
      amount: -2,
    },
    {
      first: 39,
      second: 113,
      amount: -2,
    },
    {
      first: 40,
      second: 64,
      amount: -1,
    },
    {
      first: 40,
      second: 67,
      amount: -1,
    },
    {
      first: 40,
      second: 71,
      amount: -1,
    },
    {
      first: 40,
      second: 79,
      amount: -1,
    },
    {
      first: 40,
      second: 81,
      amount: -1,
    },
    {
      first: 40,
      second: 99,
      amount: -1,
    },
    {
      first: 40,
      second: 100,
      amount: -1,
    },
    {
      first: 40,
      second: 101,
      amount: -1,
    },
    {
      first: 40,
      second: 111,
      amount: -1,
    },
    {
      first: 40,
      second: 113,
      amount: -1,
    },
    {
      first: 42,
      second: 38,
      amount: -4,
    },
    {
      first: 42,
      second: 44,
      amount: -5,
    },
    {
      first: 42,
      second: 45,
      amount: -4,
    },
    {
      first: 42,
      second: 46,
      amount: -5,
    },
    {
      first: 42,
      second: 47,
      amount: -4,
    },
    {
      first: 42,
      second: 64,
      amount: -1,
    },
    {
      first: 42,
      second: 65,
      amount: -4,
    },
    {
      first: 42,
      second: 67,
      amount: -1,
    },
    {
      first: 42,
      second: 71,
      amount: -1,
    },
    {
      first: 42,
      second: 79,
      amount: -1,
    },
    {
      first: 42,
      second: 81,
      amount: -1,
    },
    {
      first: 42,
      second: 86,
      amount: 1,
    },
    {
      first: 42,
      second: 87,
      amount: 1,
    },
    {
      first: 42,
      second: 89,
      amount: 1,
    },
    {
      first: 42,
      second: 92,
      amount: 1,
    },
    {
      first: 42,
      second: 97,
      amount: -1,
    },
    {
      first: 42,
      second: 99,
      amount: -2,
    },
    {
      first: 42,
      second: 100,
      amount: -2,
    },
    {
      first: 42,
      second: 101,
      amount: -2,
    },
    {
      first: 42,
      second: 111,
      amount: -2,
    },
    {
      first: 42,
      second: 113,
      amount: -2,
    },
    {
      first: 44,
      second: 34,
      amount: -5,
    },
    {
      first: 44,
      second: 39,
      amount: -5,
    },
    {
      first: 44,
      second: 42,
      amount: -5,
    },
    {
      first: 44,
      second: 45,
      amount: -3,
    },
    {
      first: 44,
      second: 64,
      amount: -1,
    },
    {
      first: 44,
      second: 67,
      amount: -1,
    },
    {
      first: 44,
      second: 71,
      amount: -1,
    },
    {
      first: 44,
      second: 79,
      amount: -1,
    },
    {
      first: 44,
      second: 81,
      amount: -1,
    },
    {
      first: 44,
      second: 84,
      amount: -4,
    },
    {
      first: 44,
      second: 86,
      amount: -4,
    },
    {
      first: 44,
      second: 87,
      amount: -3,
    },
    {
      first: 44,
      second: 89,
      amount: -3,
    },
    {
      first: 44,
      second: 92,
      amount: -4,
    },
    {
      first: 44,
      second: 118,
      amount: -3,
    },
    {
      first: 44,
      second: 119,
      amount: -1,
    },
    {
      first: 44,
      second: 121,
      amount: -3,
    },
    {
      first: 45,
      second: 34,
      amount: -4,
    },
    {
      first: 45,
      second: 38,
      amount: -1,
    },
    {
      first: 45,
      second: 39,
      amount: -4,
    },
    {
      first: 45,
      second: 42,
      amount: -4,
    },
    {
      first: 45,
      second: 44,
      amount: -3,
    },
    {
      first: 45,
      second: 46,
      amount: -3,
    },
    {
      first: 45,
      second: 47,
      amount: -1,
    },
    {
      first: 45,
      second: 65,
      amount: -1,
    },
    {
      first: 45,
      second: 84,
      amount: -4,
    },
    {
      first: 45,
      second: 86,
      amount: -2,
    },
    {
      first: 45,
      second: 87,
      amount: -1,
    },
    {
      first: 45,
      second: 88,
      amount: -1,
    },
    {
      first: 45,
      second: 89,
      amount: -3,
    },
    {
      first: 45,
      second: 90,
      amount: -1,
    },
    {
      first: 45,
      second: 92,
      amount: -2,
    },
    {
      first: 46,
      second: 34,
      amount: -5,
    },
    {
      first: 46,
      second: 39,
      amount: -5,
    },
    {
      first: 46,
      second: 42,
      amount: -5,
    },
    {
      first: 46,
      second: 45,
      amount: -3,
    },
    {
      first: 46,
      second: 64,
      amount: -1,
    },
    {
      first: 46,
      second: 67,
      amount: -1,
    },
    {
      first: 46,
      second: 71,
      amount: -1,
    },
    {
      first: 46,
      second: 79,
      amount: -1,
    },
    {
      first: 46,
      second: 81,
      amount: -1,
    },
    {
      first: 46,
      second: 84,
      amount: -4,
    },
    {
      first: 46,
      second: 86,
      amount: -4,
    },
    {
      first: 46,
      second: 87,
      amount: -3,
    },
    {
      first: 46,
      second: 89,
      amount: -3,
    },
    {
      first: 46,
      second: 92,
      amount: -4,
    },
    {
      first: 46,
      second: 118,
      amount: -3,
    },
    {
      first: 46,
      second: 119,
      amount: -1,
    },
    {
      first: 46,
      second: 121,
      amount: -3,
    },
    {
      first: 47,
      second: 34,
      amount: 1,
    },
    {
      first: 47,
      second: 38,
      amount: -3,
    },
    {
      first: 47,
      second: 39,
      amount: 1,
    },
    {
      first: 47,
      second: 42,
      amount: 1,
    },
    {
      first: 47,
      second: 44,
      amount: -4,
    },
    {
      first: 47,
      second: 45,
      amount: -2,
    },
    {
      first: 47,
      second: 46,
      amount: -4,
    },
    {
      first: 47,
      second: 47,
      amount: -3,
    },
    {
      first: 47,
      second: 58,
      amount: -2,
    },
    {
      first: 47,
      second: 59,
      amount: -2,
    },
    {
      first: 47,
      second: 63,
      amount: 1,
    },
    {
      first: 47,
      second: 64,
      amount: -1,
    },
    {
      first: 47,
      second: 65,
      amount: -3,
    },
    {
      first: 47,
      second: 67,
      amount: -1,
    },
    {
      first: 47,
      second: 71,
      amount: -1,
    },
    {
      first: 47,
      second: 74,
      amount: -3,
    },
    {
      first: 47,
      second: 79,
      amount: -1,
    },
    {
      first: 47,
      second: 81,
      amount: -1,
    },
    {
      first: 47,
      second: 97,
      amount: -2,
    },
    {
      first: 47,
      second: 99,
      amount: -2,
    },
    {
      first: 47,
      second: 100,
      amount: -2,
    },
    {
      first: 47,
      second: 101,
      amount: -2,
    },
    {
      first: 47,
      second: 102,
      amount: -1,
    },
    {
      first: 47,
      second: 103,
      amount: -3,
    },
    {
      first: 47,
      second: 109,
      amount: -2,
    },
    {
      first: 47,
      second: 110,
      amount: -2,
    },
    {
      first: 47,
      second: 111,
      amount: -2,
    },
    {
      first: 47,
      second: 112,
      amount: -2,
    },
    {
      first: 47,
      second: 113,
      amount: -2,
    },
    {
      first: 47,
      second: 114,
      amount: -2,
    },
    {
      first: 47,
      second: 115,
      amount: -2,
    },
    {
      first: 47,
      second: 116,
      amount: -1,
    },
    {
      first: 47,
      second: 117,
      amount: -2,
    },
    {
      first: 47,
      second: 118,
      amount: -1,
    },
    {
      first: 47,
      second: 120,
      amount: -1,
    },
    {
      first: 47,
      second: 121,
      amount: -1,
    },
    {
      first: 47,
      second: 122,
      amount: -2,
    },
    {
      first: 64,
      second: 34,
      amount: -1,
    },
    {
      first: 64,
      second: 38,
      amount: -1,
    },
    {
      first: 64,
      second: 39,
      amount: -1,
    },
    {
      first: 64,
      second: 41,
      amount: -1,
    },
    {
      first: 64,
      second: 42,
      amount: -1,
    },
    {
      first: 64,
      second: 44,
      amount: -1,
    },
    {
      first: 64,
      second: 46,
      amount: -1,
    },
    {
      first: 64,
      second: 47,
      amount: -1,
    },
    {
      first: 64,
      second: 65,
      amount: -1,
    },
    {
      first: 64,
      second: 84,
      amount: -2,
    },
    {
      first: 64,
      second: 86,
      amount: -1,
    },
    {
      first: 64,
      second: 88,
      amount: -1,
    },
    {
      first: 64,
      second: 89,
      amount: -2,
    },
    {
      first: 64,
      second: 90,
      amount: -1,
    },
    {
      first: 64,
      second: 92,
      amount: -1,
    },
    {
      first: 64,
      second: 93,
      amount: -1,
    },
    {
      first: 64,
      second: 125,
      amount: -1,
    },
    {
      first: 65,
      second: 34,
      amount: -4,
    },
    {
      first: 65,
      second: 39,
      amount: -4,
    },
    {
      first: 65,
      second: 42,
      amount: -4,
    },
    {
      first: 65,
      second: 45,
      amount: -1,
    },
    {
      first: 65,
      second: 63,
      amount: -1,
    },
    {
      first: 65,
      second: 64,
      amount: -1,
    },
    {
      first: 65,
      second: 67,
      amount: -1,
    },
    {
      first: 65,
      second: 71,
      amount: -1,
    },
    {
      first: 65,
      second: 74,
      amount: 1,
    },
    {
      first: 65,
      second: 79,
      amount: -1,
    },
    {
      first: 65,
      second: 81,
      amount: -1,
    },
    {
      first: 65,
      second: 84,
      amount: -3,
    },
    {
      first: 65,
      second: 85,
      amount: -1,
    },
    {
      first: 65,
      second: 86,
      amount: -3,
    },
    {
      first: 65,
      second: 87,
      amount: -2,
    },
    {
      first: 65,
      second: 89,
      amount: -3,
    },
    {
      first: 65,
      second: 92,
      amount: -3,
    },
    {
      first: 65,
      second: 118,
      amount: -2,
    },
    {
      first: 65,
      second: 121,
      amount: -2,
    },
    {
      first: 67,
      second: 45,
      amount: -3,
    },
    {
      first: 68,
      second: 34,
      amount: -1,
    },
    {
      first: 68,
      second: 38,
      amount: -1,
    },
    {
      first: 68,
      second: 39,
      amount: -1,
    },
    {
      first: 68,
      second: 41,
      amount: -1,
    },
    {
      first: 68,
      second: 42,
      amount: -1,
    },
    {
      first: 68,
      second: 44,
      amount: -1,
    },
    {
      first: 68,
      second: 46,
      amount: -1,
    },
    {
      first: 68,
      second: 47,
      amount: -1,
    },
    {
      first: 68,
      second: 65,
      amount: -1,
    },
    {
      first: 68,
      second: 84,
      amount: -2,
    },
    {
      first: 68,
      second: 86,
      amount: -1,
    },
    {
      first: 68,
      second: 88,
      amount: -1,
    },
    {
      first: 68,
      second: 89,
      amount: -2,
    },
    {
      first: 68,
      second: 90,
      amount: -1,
    },
    {
      first: 68,
      second: 92,
      amount: -1,
    },
    {
      first: 68,
      second: 93,
      amount: -1,
    },
    {
      first: 68,
      second: 125,
      amount: -1,
    },
    {
      first: 70,
      second: 38,
      amount: -3,
    },
    {
      first: 70,
      second: 44,
      amount: -4,
    },
    {
      first: 70,
      second: 46,
      amount: -4,
    },
    {
      first: 70,
      second: 47,
      amount: -3,
    },
    {
      first: 70,
      second: 58,
      amount: -1,
    },
    {
      first: 70,
      second: 59,
      amount: -1,
    },
    {
      first: 70,
      second: 63,
      amount: 1,
    },
    {
      first: 70,
      second: 65,
      amount: -3,
    },
    {
      first: 70,
      second: 74,
      amount: -4,
    },
    {
      first: 70,
      second: 99,
      amount: -1,
    },
    {
      first: 70,
      second: 100,
      amount: -1,
    },
    {
      first: 70,
      second: 101,
      amount: -1,
    },
    {
      first: 70,
      second: 109,
      amount: -1,
    },
    {
      first: 70,
      second: 110,
      amount: -1,
    },
    {
      first: 70,
      second: 111,
      amount: -1,
    },
    {
      first: 70,
      second: 112,
      amount: -1,
    },
    {
      first: 70,
      second: 113,
      amount: -1,
    },
    {
      first: 70,
      second: 114,
      amount: -1,
    },
    {
      first: 70,
      second: 117,
      amount: -1,
    },
    {
      first: 74,
      second: 38,
      amount: -1,
    },
    {
      first: 74,
      second: 44,
      amount: -1,
    },
    {
      first: 74,
      second: 46,
      amount: -1,
    },
    {
      first: 74,
      second: 47,
      amount: -1,
    },
    {
      first: 74,
      second: 65,
      amount: -1,
    },
    {
      first: 75,
      second: 45,
      amount: -1,
    },
    {
      first: 75,
      second: 64,
      amount: -1,
    },
    {
      first: 75,
      second: 67,
      amount: -1,
    },
    {
      first: 75,
      second: 71,
      amount: -1,
    },
    {
      first: 75,
      second: 79,
      amount: -1,
    },
    {
      first: 75,
      second: 81,
      amount: -1,
    },
    {
      first: 75,
      second: 99,
      amount: -1,
    },
    {
      first: 75,
      second: 100,
      amount: -1,
    },
    {
      first: 75,
      second: 101,
      amount: -1,
    },
    {
      first: 75,
      second: 102,
      amount: -1,
    },
    {
      first: 75,
      second: 111,
      amount: -1,
    },
    {
      first: 75,
      second: 113,
      amount: -1,
    },
    {
      first: 75,
      second: 116,
      amount: -2,
    },
    {
      first: 75,
      second: 118,
      amount: -1,
    },
    {
      first: 75,
      second: 119,
      amount: -1,
    },
    {
      first: 75,
      second: 121,
      amount: -1,
    },
    {
      first: 76,
      second: 34,
      amount: -6,
    },
    {
      first: 76,
      second: 39,
      amount: -6,
    },
    {
      first: 76,
      second: 42,
      amount: -6,
    },
    {
      first: 76,
      second: 44,
      amount: 1,
    },
    {
      first: 76,
      second: 45,
      amount: -4,
    },
    {
      first: 76,
      second: 46,
      amount: 1,
    },
    {
      first: 76,
      second: 63,
      amount: -1,
    },
    {
      first: 76,
      second: 64,
      amount: -2,
    },
    {
      first: 76,
      second: 67,
      amount: -2,
    },
    {
      first: 76,
      second: 71,
      amount: -2,
    },
    {
      first: 76,
      second: 79,
      amount: -2,
    },
    {
      first: 76,
      second: 81,
      amount: -2,
    },
    {
      first: 76,
      second: 84,
      amount: -4,
    },
    {
      first: 76,
      second: 86,
      amount: -4,
    },
    {
      first: 76,
      second: 87,
      amount: -3,
    },
    {
      first: 76,
      second: 89,
      amount: -4,
    },
    {
      first: 76,
      second: 92,
      amount: -4,
    },
    {
      first: 76,
      second: 99,
      amount: -1,
    },
    {
      first: 76,
      second: 100,
      amount: -1,
    },
    {
      first: 76,
      second: 101,
      amount: -1,
    },
    {
      first: 76,
      second: 111,
      amount: -1,
    },
    {
      first: 76,
      second: 113,
      amount: -1,
    },
    {
      first: 76,
      second: 118,
      amount: -2,
    },
    {
      first: 76,
      second: 119,
      amount: -2,
    },
    {
      first: 76,
      second: 121,
      amount: -2,
    },
    {
      first: 79,
      second: 34,
      amount: -1,
    },
    {
      first: 79,
      second: 38,
      amount: -1,
    },
    {
      first: 79,
      second: 39,
      amount: -1,
    },
    {
      first: 79,
      second: 41,
      amount: -1,
    },
    {
      first: 79,
      second: 42,
      amount: -1,
    },
    {
      first: 79,
      second: 44,
      amount: -1,
    },
    {
      first: 79,
      second: 46,
      amount: -1,
    },
    {
      first: 79,
      second: 47,
      amount: -1,
    },
    {
      first: 79,
      second: 65,
      amount: -1,
    },
    {
      first: 79,
      second: 84,
      amount: -2,
    },
    {
      first: 79,
      second: 86,
      amount: -1,
    },
    {
      first: 79,
      second: 88,
      amount: -1,
    },
    {
      first: 79,
      second: 89,
      amount: -2,
    },
    {
      first: 79,
      second: 90,
      amount: -1,
    },
    {
      first: 79,
      second: 92,
      amount: -1,
    },
    {
      first: 79,
      second: 93,
      amount: -1,
    },
    {
      first: 79,
      second: 125,
      amount: -1,
    },
    {
      first: 80,
      second: 38,
      amount: -3,
    },
    {
      first: 80,
      second: 44,
      amount: -5,
    },
    {
      first: 80,
      second: 46,
      amount: -5,
    },
    {
      first: 80,
      second: 47,
      amount: -3,
    },
    {
      first: 80,
      second: 65,
      amount: -3,
    },
    {
      first: 80,
      second: 74,
      amount: -4,
    },
    {
      first: 80,
      second: 97,
      amount: -1,
    },
    {
      first: 80,
      second: 99,
      amount: -1,
    },
    {
      first: 80,
      second: 100,
      amount: -1,
    },
    {
      first: 80,
      second: 101,
      amount: -1,
    },
    {
      first: 80,
      second: 111,
      amount: -1,
    },
    {
      first: 80,
      second: 113,
      amount: -1,
    },
    {
      first: 81,
      second: 34,
      amount: -1,
    },
    {
      first: 81,
      second: 38,
      amount: -1,
    },
    {
      first: 81,
      second: 39,
      amount: -1,
    },
    {
      first: 81,
      second: 41,
      amount: -1,
    },
    {
      first: 81,
      second: 42,
      amount: -1,
    },
    {
      first: 81,
      second: 44,
      amount: -1,
    },
    {
      first: 81,
      second: 46,
      amount: -1,
    },
    {
      first: 81,
      second: 47,
      amount: -1,
    },
    {
      first: 81,
      second: 65,
      amount: -1,
    },
    {
      first: 81,
      second: 84,
      amount: -2,
    },
    {
      first: 81,
      second: 86,
      amount: -1,
    },
    {
      first: 81,
      second: 88,
      amount: -1,
    },
    {
      first: 81,
      second: 89,
      amount: -2,
    },
    {
      first: 81,
      second: 90,
      amount: -1,
    },
    {
      first: 81,
      second: 92,
      amount: -1,
    },
    {
      first: 81,
      second: 93,
      amount: -1,
    },
    {
      first: 81,
      second: 125,
      amount: -1,
    },
    {
      first: 82,
      second: 64,
      amount: -1,
    },
    {
      first: 82,
      second: 67,
      amount: -1,
    },
    {
      first: 82,
      second: 71,
      amount: -1,
    },
    {
      first: 82,
      second: 79,
      amount: -1,
    },
    {
      first: 82,
      second: 81,
      amount: -1,
    },
    {
      first: 82,
      second: 84,
      amount: -1,
    },
    {
      first: 82,
      second: 85,
      amount: -1,
    },
    {
      first: 84,
      second: 38,
      amount: -3,
    },
    {
      first: 84,
      second: 44,
      amount: -4,
    },
    {
      first: 84,
      second: 45,
      amount: -4,
    },
    {
      first: 84,
      second: 46,
      amount: -4,
    },
    {
      first: 84,
      second: 47,
      amount: -3,
    },
    {
      first: 84,
      second: 58,
      amount: -3,
    },
    {
      first: 84,
      second: 59,
      amount: -3,
    },
    {
      first: 84,
      second: 64,
      amount: -2,
    },
    {
      first: 84,
      second: 65,
      amount: -3,
    },
    {
      first: 84,
      second: 67,
      amount: -2,
    },
    {
      first: 84,
      second: 71,
      amount: -2,
    },
    {
      first: 84,
      second: 74,
      amount: -4,
    },
    {
      first: 84,
      second: 79,
      amount: -2,
    },
    {
      first: 84,
      second: 81,
      amount: -2,
    },
    {
      first: 84,
      second: 97,
      amount: -5,
    },
    {
      first: 84,
      second: 99,
      amount: -4,
    },
    {
      first: 84,
      second: 100,
      amount: -4,
    },
    {
      first: 84,
      second: 101,
      amount: -4,
    },
    {
      first: 84,
      second: 103,
      amount: -4,
    },
    {
      first: 84,
      second: 109,
      amount: -3,
    },
    {
      first: 84,
      second: 110,
      amount: -3,
    },
    {
      first: 84,
      second: 111,
      amount: -4,
    },
    {
      first: 84,
      second: 112,
      amount: -3,
    },
    {
      first: 84,
      second: 113,
      amount: -4,
    },
    {
      first: 84,
      second: 114,
      amount: -3,
    },
    {
      first: 84,
      second: 115,
      amount: -3,
    },
    {
      first: 84,
      second: 117,
      amount: -3,
    },
    {
      first: 84,
      second: 118,
      amount: -4,
    },
    {
      first: 84,
      second: 119,
      amount: -3,
    },
    {
      first: 84,
      second: 120,
      amount: -3,
    },
    {
      first: 84,
      second: 121,
      amount: -4,
    },
    {
      first: 84,
      second: 122,
      amount: -3,
    },
    {
      first: 85,
      second: 38,
      amount: -1,
    },
    {
      first: 85,
      second: 44,
      amount: -1,
    },
    {
      first: 85,
      second: 46,
      amount: -1,
    },
    {
      first: 85,
      second: 47,
      amount: -1,
    },
    {
      first: 85,
      second: 65,
      amount: -1,
    },
    {
      first: 86,
      second: 34,
      amount: 1,
    },
    {
      first: 86,
      second: 38,
      amount: -3,
    },
    {
      first: 86,
      second: 39,
      amount: 1,
    },
    {
      first: 86,
      second: 42,
      amount: 1,
    },
    {
      first: 86,
      second: 44,
      amount: -4,
    },
    {
      first: 86,
      second: 45,
      amount: -2,
    },
    {
      first: 86,
      second: 46,
      amount: -4,
    },
    {
      first: 86,
      second: 47,
      amount: -3,
    },
    {
      first: 86,
      second: 58,
      amount: -2,
    },
    {
      first: 86,
      second: 59,
      amount: -2,
    },
    {
      first: 86,
      second: 63,
      amount: 1,
    },
    {
      first: 86,
      second: 64,
      amount: -1,
    },
    {
      first: 86,
      second: 65,
      amount: -3,
    },
    {
      first: 86,
      second: 67,
      amount: -1,
    },
    {
      first: 86,
      second: 71,
      amount: -1,
    },
    {
      first: 86,
      second: 74,
      amount: -3,
    },
    {
      first: 86,
      second: 79,
      amount: -1,
    },
    {
      first: 86,
      second: 81,
      amount: -1,
    },
    {
      first: 86,
      second: 97,
      amount: -2,
    },
    {
      first: 86,
      second: 99,
      amount: -2,
    },
    {
      first: 86,
      second: 100,
      amount: -2,
    },
    {
      first: 86,
      second: 101,
      amount: -2,
    },
    {
      first: 86,
      second: 102,
      amount: -1,
    },
    {
      first: 86,
      second: 103,
      amount: -3,
    },
    {
      first: 86,
      second: 109,
      amount: -2,
    },
    {
      first: 86,
      second: 110,
      amount: -2,
    },
    {
      first: 86,
      second: 111,
      amount: -2,
    },
    {
      first: 86,
      second: 112,
      amount: -2,
    },
    {
      first: 86,
      second: 113,
      amount: -2,
    },
    {
      first: 86,
      second: 114,
      amount: -2,
    },
    {
      first: 86,
      second: 115,
      amount: -2,
    },
    {
      first: 86,
      second: 116,
      amount: -1,
    },
    {
      first: 86,
      second: 117,
      amount: -2,
    },
    {
      first: 86,
      second: 118,
      amount: -1,
    },
    {
      first: 86,
      second: 120,
      amount: -1,
    },
    {
      first: 86,
      second: 121,
      amount: -1,
    },
    {
      first: 86,
      second: 122,
      amount: -2,
    },
    {
      first: 87,
      second: 34,
      amount: 1,
    },
    {
      first: 87,
      second: 38,
      amount: -2,
    },
    {
      first: 87,
      second: 39,
      amount: 1,
    },
    {
      first: 87,
      second: 42,
      amount: 1,
    },
    {
      first: 87,
      second: 44,
      amount: -3,
    },
    {
      first: 87,
      second: 45,
      amount: -1,
    },
    {
      first: 87,
      second: 46,
      amount: -3,
    },
    {
      first: 87,
      second: 47,
      amount: -2,
    },
    {
      first: 87,
      second: 63,
      amount: 1,
    },
    {
      first: 87,
      second: 65,
      amount: -2,
    },
    {
      first: 87,
      second: 74,
      amount: -2,
    },
    {
      first: 87,
      second: 97,
      amount: -2,
    },
    {
      first: 87,
      second: 99,
      amount: -1,
    },
    {
      first: 87,
      second: 100,
      amount: -1,
    },
    {
      first: 87,
      second: 101,
      amount: -1,
    },
    {
      first: 87,
      second: 103,
      amount: -2,
    },
    {
      first: 87,
      second: 111,
      amount: -1,
    },
    {
      first: 87,
      second: 113,
      amount: -1,
    },
    {
      first: 87,
      second: 115,
      amount: -1,
    },
    {
      first: 88,
      second: 45,
      amount: -1,
    },
    {
      first: 88,
      second: 64,
      amount: -1,
    },
    {
      first: 88,
      second: 67,
      amount: -1,
    },
    {
      first: 88,
      second: 71,
      amount: -1,
    },
    {
      first: 88,
      second: 79,
      amount: -1,
    },
    {
      first: 88,
      second: 81,
      amount: -1,
    },
    {
      first: 88,
      second: 99,
      amount: -1,
    },
    {
      first: 88,
      second: 100,
      amount: -1,
    },
    {
      first: 88,
      second: 101,
      amount: -1,
    },
    {
      first: 88,
      second: 102,
      amount: -1,
    },
    {
      first: 88,
      second: 111,
      amount: -1,
    },
    {
      first: 88,
      second: 113,
      amount: -1,
    },
    {
      first: 88,
      second: 116,
      amount: -2,
    },
    {
      first: 88,
      second: 118,
      amount: -1,
    },
    {
      first: 88,
      second: 119,
      amount: -1,
    },
    {
      first: 88,
      second: 121,
      amount: -1,
    },
    {
      first: 89,
      second: 34,
      amount: 1,
    },
    {
      first: 89,
      second: 38,
      amount: -3,
    },
    {
      first: 89,
      second: 39,
      amount: 1,
    },
    {
      first: 89,
      second: 42,
      amount: 1,
    },
    {
      first: 89,
      second: 44,
      amount: -3,
    },
    {
      first: 89,
      second: 45,
      amount: -3,
    },
    {
      first: 89,
      second: 46,
      amount: -3,
    },
    {
      first: 89,
      second: 47,
      amount: -3,
    },
    {
      first: 89,
      second: 58,
      amount: -3,
    },
    {
      first: 89,
      second: 59,
      amount: -3,
    },
    {
      first: 89,
      second: 63,
      amount: 1,
    },
    {
      first: 89,
      second: 64,
      amount: -2,
    },
    {
      first: 89,
      second: 65,
      amount: -3,
    },
    {
      first: 89,
      second: 67,
      amount: -2,
    },
    {
      first: 89,
      second: 71,
      amount: -2,
    },
    {
      first: 89,
      second: 74,
      amount: -4,
    },
    {
      first: 89,
      second: 79,
      amount: -2,
    },
    {
      first: 89,
      second: 81,
      amount: -2,
    },
    {
      first: 89,
      second: 97,
      amount: -3,
    },
    {
      first: 89,
      second: 99,
      amount: -3,
    },
    {
      first: 89,
      second: 100,
      amount: -3,
    },
    {
      first: 89,
      second: 101,
      amount: -3,
    },
    {
      first: 89,
      second: 103,
      amount: -4,
    },
    {
      first: 89,
      second: 109,
      amount: -3,
    },
    {
      first: 89,
      second: 110,
      amount: -3,
    },
    {
      first: 89,
      second: 111,
      amount: -3,
    },
    {
      first: 89,
      second: 112,
      amount: -3,
    },
    {
      first: 89,
      second: 113,
      amount: -3,
    },
    {
      first: 89,
      second: 114,
      amount: -3,
    },
    {
      first: 89,
      second: 115,
      amount: -3,
    },
    {
      first: 89,
      second: 117,
      amount: -3,
    },
    {
      first: 89,
      second: 118,
      amount: -2,
    },
    {
      first: 89,
      second: 119,
      amount: -2,
    },
    {
      first: 89,
      second: 120,
      amount: -3,
    },
    {
      first: 89,
      second: 121,
      amount: -2,
    },
    {
      first: 90,
      second: 45,
      amount: -1,
    },
    {
      first: 90,
      second: 63,
      amount: 1,
    },
    {
      first: 90,
      second: 64,
      amount: -1,
    },
    {
      first: 90,
      second: 67,
      amount: -1,
    },
    {
      first: 90,
      second: 71,
      amount: -1,
    },
    {
      first: 90,
      second: 79,
      amount: -1,
    },
    {
      first: 90,
      second: 81,
      amount: -1,
    },
    {
      first: 90,
      second: 99,
      amount: -1,
    },
    {
      first: 90,
      second: 100,
      amount: -1,
    },
    {
      first: 90,
      second: 101,
      amount: -1,
    },
    {
      first: 90,
      second: 111,
      amount: -1,
    },
    {
      first: 90,
      second: 113,
      amount: -1,
    },
    {
      first: 90,
      second: 115,
      amount: -1,
    },
    {
      first: 90,
      second: 118,
      amount: -1,
    },
    {
      first: 90,
      second: 121,
      amount: -1,
    },
    {
      first: 91,
      second: 64,
      amount: -1,
    },
    {
      first: 91,
      second: 67,
      amount: -1,
    },
    {
      first: 91,
      second: 71,
      amount: -1,
    },
    {
      first: 91,
      second: 79,
      amount: -1,
    },
    {
      first: 91,
      second: 81,
      amount: -1,
    },
    {
      first: 91,
      second: 99,
      amount: -1,
    },
    {
      first: 91,
      second: 100,
      amount: -1,
    },
    {
      first: 91,
      second: 101,
      amount: -1,
    },
    {
      first: 91,
      second: 111,
      amount: -1,
    },
    {
      first: 91,
      second: 113,
      amount: -1,
    },
    {
      first: 92,
      second: 34,
      amount: -4,
    },
    {
      first: 92,
      second: 39,
      amount: -4,
    },
    {
      first: 92,
      second: 42,
      amount: -4,
    },
    {
      first: 92,
      second: 45,
      amount: -1,
    },
    {
      first: 92,
      second: 63,
      amount: -1,
    },
    {
      first: 92,
      second: 64,
      amount: -1,
    },
    {
      first: 92,
      second: 67,
      amount: -1,
    },
    {
      first: 92,
      second: 71,
      amount: -1,
    },
    {
      first: 92,
      second: 74,
      amount: 1,
    },
    {
      first: 92,
      second: 79,
      amount: -1,
    },
    {
      first: 92,
      second: 81,
      amount: -1,
    },
    {
      first: 92,
      second: 84,
      amount: -3,
    },
    {
      first: 92,
      second: 85,
      amount: -1,
    },
    {
      first: 92,
      second: 86,
      amount: -3,
    },
    {
      first: 92,
      second: 87,
      amount: -2,
    },
    {
      first: 92,
      second: 89,
      amount: -3,
    },
    {
      first: 92,
      second: 92,
      amount: -3,
    },
    {
      first: 92,
      second: 118,
      amount: -2,
    },
    {
      first: 92,
      second: 121,
      amount: -2,
    },
    {
      first: 97,
      second: 34,
      amount: -2,
    },
    {
      first: 97,
      second: 39,
      amount: -2,
    },
    {
      first: 97,
      second: 42,
      amount: -2,
    },
    {
      first: 97,
      second: 118,
      amount: -1,
    },
    {
      first: 97,
      second: 119,
      amount: 0,
    },
    {
      first: 97,
      second: 121,
      amount: -1,
    },
    {
      first: 98,
      second: 34,
      amount: -2,
    },
    {
      first: 98,
      second: 39,
      amount: -2,
    },
    {
      first: 98,
      second: 41,
      amount: -1,
    },
    {
      first: 98,
      second: 42,
      amount: -2,
    },
    {
      first: 98,
      second: 86,
      amount: -2,
    },
    {
      first: 98,
      second: 87,
      amount: -1,
    },
    {
      first: 98,
      second: 92,
      amount: -2,
    },
    {
      first: 98,
      second: 93,
      amount: -1,
    },
    {
      first: 98,
      second: 118,
      amount: -1,
    },
    {
      first: 98,
      second: 120,
      amount: -1,
    },
    {
      first: 98,
      second: 121,
      amount: -1,
    },
    {
      first: 98,
      second: 125,
      amount: -1,
    },
    {
      first: 101,
      second: 34,
      amount: -2,
    },
    {
      first: 101,
      second: 39,
      amount: -2,
    },
    {
      first: 101,
      second: 41,
      amount: -1,
    },
    {
      first: 101,
      second: 42,
      amount: -2,
    },
    {
      first: 101,
      second: 86,
      amount: -2,
    },
    {
      first: 101,
      second: 87,
      amount: -1,
    },
    {
      first: 101,
      second: 92,
      amount: -2,
    },
    {
      first: 101,
      second: 93,
      amount: -1,
    },
    {
      first: 101,
      second: 118,
      amount: -1,
    },
    {
      first: 101,
      second: 120,
      amount: -1,
    },
    {
      first: 101,
      second: 121,
      amount: -1,
    },
    {
      first: 101,
      second: 125,
      amount: -1,
    },
    {
      first: 102,
      second: 34,
      amount: 1,
    },
    {
      first: 102,
      second: 39,
      amount: 1,
    },
    {
      first: 102,
      second: 42,
      amount: 1,
    },
    {
      first: 102,
      second: 44,
      amount: -3,
    },
    {
      first: 102,
      second: 46,
      amount: -3,
    },
    {
      first: 104,
      second: 34,
      amount: -2,
    },
    {
      first: 104,
      second: 39,
      amount: -2,
    },
    {
      first: 104,
      second: 42,
      amount: -2,
    },
    {
      first: 104,
      second: 118,
      amount: -1,
    },
    {
      first: 104,
      second: 119,
      amount: 0,
    },
    {
      first: 104,
      second: 121,
      amount: -1,
    },
    {
      first: 107,
      second: 99,
      amount: -1,
    },
    {
      first: 107,
      second: 100,
      amount: -1,
    },
    {
      first: 107,
      second: 101,
      amount: -1,
    },
    {
      first: 107,
      second: 111,
      amount: -1,
    },
    {
      first: 107,
      second: 113,
      amount: -1,
    },
    {
      first: 109,
      second: 34,
      amount: -2,
    },
    {
      first: 109,
      second: 39,
      amount: -2,
    },
    {
      first: 109,
      second: 42,
      amount: -2,
    },
    {
      first: 109,
      second: 118,
      amount: -1,
    },
    {
      first: 109,
      second: 119,
      amount: 0,
    },
    {
      first: 109,
      second: 121,
      amount: -1,
    },
    {
      first: 110,
      second: 34,
      amount: -2,
    },
    {
      first: 110,
      second: 39,
      amount: -2,
    },
    {
      first: 110,
      second: 42,
      amount: -2,
    },
    {
      first: 110,
      second: 118,
      amount: -1,
    },
    {
      first: 110,
      second: 119,
      amount: 0,
    },
    {
      first: 110,
      second: 121,
      amount: -1,
    },
    {
      first: 111,
      second: 34,
      amount: -2,
    },
    {
      first: 111,
      second: 39,
      amount: -2,
    },
    {
      first: 111,
      second: 41,
      amount: -1,
    },
    {
      first: 111,
      second: 42,
      amount: -2,
    },
    {
      first: 111,
      second: 86,
      amount: -2,
    },
    {
      first: 111,
      second: 87,
      amount: -1,
    },
    {
      first: 111,
      second: 92,
      amount: -2,
    },
    {
      first: 111,
      second: 93,
      amount: -1,
    },
    {
      first: 111,
      second: 118,
      amount: -1,
    },
    {
      first: 111,
      second: 120,
      amount: -1,
    },
    {
      first: 111,
      second: 121,
      amount: -1,
    },
    {
      first: 111,
      second: 125,
      amount: -1,
    },
    {
      first: 112,
      second: 34,
      amount: -2,
    },
    {
      first: 112,
      second: 39,
      amount: -2,
    },
    {
      first: 112,
      second: 41,
      amount: -1,
    },
    {
      first: 112,
      second: 42,
      amount: -2,
    },
    {
      first: 112,
      second: 86,
      amount: -2,
    },
    {
      first: 112,
      second: 87,
      amount: -1,
    },
    {
      first: 112,
      second: 92,
      amount: -2,
    },
    {
      first: 112,
      second: 93,
      amount: -1,
    },
    {
      first: 112,
      second: 118,
      amount: -1,
    },
    {
      first: 112,
      second: 120,
      amount: -1,
    },
    {
      first: 112,
      second: 121,
      amount: -1,
    },
    {
      first: 112,
      second: 125,
      amount: -1,
    },
    {
      first: 114,
      second: 44,
      amount: -3,
    },
    {
      first: 114,
      second: 46,
      amount: -3,
    },
    {
      first: 114,
      second: 97,
      amount: -1,
    },
    {
      first: 118,
      second: 38,
      amount: -2,
    },
    {
      first: 118,
      second: 44,
      amount: -3,
    },
    {
      first: 118,
      second: 46,
      amount: -3,
    },
    {
      first: 118,
      second: 47,
      amount: -2,
    },
    {
      first: 118,
      second: 65,
      amount: -2,
    },
    {
      first: 118,
      second: 99,
      amount: -1,
    },
    {
      first: 118,
      second: 100,
      amount: -1,
    },
    {
      first: 118,
      second: 101,
      amount: -1,
    },
    {
      first: 118,
      second: 111,
      amount: -1,
    },
    {
      first: 118,
      second: 113,
      amount: -1,
    },
    {
      first: 119,
      second: 44,
      amount: -1,
    },
    {
      first: 119,
      second: 46,
      amount: -1,
    },
    {
      first: 120,
      second: 99,
      amount: -1,
    },
    {
      first: 120,
      second: 100,
      amount: -1,
    },
    {
      first: 120,
      second: 101,
      amount: -1,
    },
    {
      first: 120,
      second: 111,
      amount: -1,
    },
    {
      first: 120,
      second: 113,
      amount: -1,
    },
    {
      first: 121,
      second: 38,
      amount: -2,
    },
    {
      first: 121,
      second: 44,
      amount: -3,
    },
    {
      first: 121,
      second: 46,
      amount: -3,
    },
    {
      first: 121,
      second: 47,
      amount: -2,
    },
    {
      first: 121,
      second: 65,
      amount: -2,
    },
    {
      first: 121,
      second: 99,
      amount: -1,
    },
    {
      first: 121,
      second: 100,
      amount: -1,
    },
    {
      first: 121,
      second: 101,
      amount: -1,
    },
    {
      first: 121,
      second: 111,
      amount: -1,
    },
    {
      first: 121,
      second: 113,
      amount: -1,
    },
    {
      first: 123,
      second: 64,
      amount: -1,
    },
    {
      first: 123,
      second: 67,
      amount: -1,
    },
    {
      first: 123,
      second: 71,
      amount: -1,
    },
    {
      first: 123,
      second: 79,
      amount: -1,
    },
    {
      first: 123,
      second: 81,
      amount: -1,
    },
    {
      first: 123,
      second: 99,
      amount: -1,
    },
    {
      first: 123,
      second: 100,
      amount: -1,
    },
    {
      first: 123,
      second: 101,
      amount: -1,
    },
    {
      first: 123,
      second: 111,
      amount: -1,
    },
    {
      first: 123,
      second: 113,
      amount: -1,
    },
  ],
};

const latoImage =
  "data:image/png;base64,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";
